import React from 'react'
import guy from '../../images/image 21.png'
import { useLanguage } from "../../Providers/LanguageContext";
const UserBanner = ({ capital, personal, general,bank }) => {
  const { language, currentLanguage } = useLanguage();

  return (
    <>
      <div className="general_user_banner_Wrapper">

        <div className="container-fluid general_user_banner_content_wrapper">
          <div className="left_banner_content">
            {general && <h1>{language.fisi_key_benifits}   {language.general_app_platform}</h1>}
            {capital && <h1>    {language.fisi_key_benifits}  {language.capital_provider}</h1>}
            {personal && <h1>    {language.fisi_key_benifits}  {language.personal_and_household}</h1>}
            {bank && <h1> {language.fisi_key_benifits}    {language.bank_and_industry}</h1>}
           { !bank && <h6>Fisibility can consolidate financial data from multiple sources, 
            which makes it easier for investors to track the performance of their 
            portfolio companies.</h6>}
          { bank &&  <h6>Fisibility's comprehensive data audit 
          capabilities help banks monitor the ongoing financial 
          performance of their loan portfolios, reducing the risk 
          of non-performing loans and loan compliance issues.</h6>}
          </div>
          <div className="right_banner_content">
            <img src={guy} />
          </div>
        </div>
      </div>
    </>
  )
}

export default UserBanner
